import { createContext, forwardRef, useContext } from "react";
import { VariableSizeList } from "react-window";
import { colorPrimary } from "../../constants/colors";

const ITEM_PADDING = 8;

const OuterElementContext = createContext<React.HTMLAttributes<HTMLElement> | undefined>(undefined);

const OuterElementType = forwardRef<HTMLDivElement>((props, ref) => {
	const outerProps = useContext(OuterElementContext);
	return <div ref={ref} {...props} {...outerProps} />;
});

function renderRow(props: any) {
	const { data, index, style } = props;
	const [optionProps, option] = data[index];

	return (
		<li
			{...optionProps}
			style={{
				...style,
				top: (style.top as number) + ITEM_PADDING,
				fontSize: 12,
				color: colorPrimary,
				padding: "4px 6px",
				textAlign: "left",
			}}
		>
			{option}
		</li>
	);
}

const VirtualListBox = forwardRef<HTMLDivElement, any>(function VirtualListBox(props, ref) {
	const { children, ...other } = props;
	const itemData = (children as React.ReactNode[]).map((child) => child);
	const itemHeights = itemData.map(([_, option]: any) => {
		const text = typeof option === "string" ? option : "";
		const lines = Math.ceil(text.length / 30);
		return Math.max(36, lines * 20);
	});
	const itemCount = itemData.length;
	const totalHeight = itemHeights.slice(0, 8).reduce((acc, h) => acc + h, 0) + 2 * ITEM_PADDING; // 8 items max, each with padding

	return (
		<div ref={ref}>
			<OuterElementContext.Provider value={other}>
				<VariableSizeList
					height={totalHeight}
					width="100%"
					itemSize={(i: number) => itemHeights[i]}
					itemCount={itemCount}
					outerElementType={OuterElementType}
					innerElementType="ul"
					itemData={itemData}
					overscanCount={5}
				>
					{renderRow}
				</VariableSizeList>
			</OuterElementContext.Provider>
		</div>
	);
});

export default VirtualListBox;
